import * as ts from '../../common/Translator'
import {EditScreenGroup} from "./EditScreenGroup";
import * as actionBlock from "./EditActionBlock";
import {areEqual, nextId, registerOnWindowResize} from "../../common/NamaCommon";
import * as EditScreenHeader from "./EditScreenHeader";
import {NamaGridWidget} from "../../grid/NamaGridWidget";
import {EmbeddedListView} from "./EmbeddedListView";
import {EmbeddedReportAndDashboardView} from "./EmbeddedReportAndDashboardView";
import * as DomainBaseFieldIDs from "../../constants/DomainBaseFieldIDs";
import * as BSEntities from "../../constants/BSEntities";
import {FlatDTOCriteriaEditor} from "./FlatDTOCriteriaEditor";
import {DiscussionRecordWidget} from "./DiscussionRecordWidget";
import {isPageHidden} from "../../routing/EditPresenter";

/**
 *
 * @param appendTo {NamaJquery|HTMLElement}
 * @param presenter {EditPresenter}
 * @returns {*|NamaJquery|HTMLElement}
 */
export function drawEditScreen(appendTo, presenter) {
    let splitterContainer = createContainer();
    let container = splitterContainer.find("#tabstrip.editScreen");
    EditScreenHeader.render(presenter).appendTo(appendTo);
    container.kendoTabStrip({
        animation: false, select: (e) => {
            presenter.onPageChanged($(e.item).index());
        }
    });
    drawPagesContent(container, presenter, 0);
    splitterContainer.appendTo(appendTo);
    if(!presenter.simpleEntityContainer)
    {
        setTimeout(() => setMaxHeightOfTabStrip(appendTo));
        registerResizeEventIfNeeded(appendTo);
    }
    return appendTo;
}

function createContainer() {
    return $(`<div id = "splitter"><div class="editScreen ra-section" id="tabstrip">
                    <ul id="pageTabs"></ul>   
                </div><div id="treeView"></div></div>`);
}

/**
 * @param container {NamaJquery}
 * @param presenter {EditPresenter}
 * @returns {*|NamaJquery|HTMLElement}
 */
export function drawPagesContent(container, presenter, oldPagesCount) {
    let pages = presenter.editLayout.pages;
    let tabStripData = container.data("kendoTabStrip");
    presenter.noGroupsAdded = true;
    let addedPages = 0;
    for (let pageIndex = 0; pageIndex < pages.length; pageIndex++) {
        if (isPageHidden(pages[pageIndex], presenter.entityType, pageIndex))
            continue;
        let actualPageIndex = oldPagesCount + addedPages;
        presenter.setDrawingPageIndex(actualPageIndex);
        let pageContent = drawPage(actualPageIndex, pages[pageIndex], presenter.metadata, presenter);
        let page = presenter.editLayout.pages[pageIndex];
        let title = ts.translateNaMaText(page.title, presenter.entityType) || ts.translateId("main", presenter.entityType);
        let divId = nextId();
        tabStripData.append({text: title, content: `<div id="${divId}"></div>`})
        container.find("#" + divId).append(pageContent);
        addedPages++;
    }
}

function isDiscussionBlock(block) {
    return block.editScreenBlock && areEqual(block.fieldId, "discussions");
}

function createBlockWidgetFor(presenter, block, groups) {
    if (isDiscussionBlock(block)) {
        let discussionRecordWidget = new DiscussionRecordWidget(block, presenter, groups);
        presenter.addToDiscussionWidgets(discussionRecordWidget);
        discussionRecordWidget.render();
    }
    if (isCriteriaDefinitionCriteria(block, presenter.metaData))
        return new FlatDTOCriteriaEditor(block, presenter, getOwnerTypeField(presenter.metaData.owner.ownerId)).render();
}

function isCriteriaDefinitionCriteria(block, metaData) {
    return areEqual(metaData.owner.ownerId, BSEntities.CriteriaDefinition)
        && areEqual(block.fieldId, DomainBaseFieldIDs.CriteriaDefinition_criteria);
}

function getOwnerTypeField(ownerId) {
    if (areEqual(ownerId, BSEntities.CriteriaDefinition))
        return DomainBaseFieldIDs.CriteriaDefinition_forType;
    return null;
}


/**
 *
 * @param pageIndex {number}
 * @param page
 * @param metaData
 * @param presenter {EditPresenter}
 * @returns {*|NamaJquery|HTMLElement}
 */
function drawPage(pageIndex, page, metaData, presenter) {
    let groupsContainer = createPageGroupsContainer();
    let groups = groupsContainer.find(".pagePanelsContainer");
    for (let i = 0; i < page.blocks.length; i++) {
        let block = page.blocks[i];
        if (block.editScreenGroup) {
            let groupWidget = new EditScreenGroup().drawGroup(block, metaData, presenter, i);
            if (!groupWidget)
                continue;
            groups.append(groupWidget);
            if (block.title)
                presenter.addWidgetToSearchableWidgets(pageIndex, groupWidget.find(".widgetsList"), block, block.title.resourceId);
            presenter.noGroupsAdded = false;
        } else if (block.editScreenGrid) {
            let hasFields = NamaGridWidget.hasColumns(block, metaData, presenter);

            if (hasFields) {
                groups.append(new NamaGridWidget({
                    owner: presenter,
                    grid: block,
                    metaData: metaData,
                    id: block.fieldId
                }).createElement())
            }
        } else if (block.editScreenDashBoard) {
            groups.append(new EmbeddedReportAndDashboardView({
                owner: presenter,
                block: block,
                editPresenter: presenter,
                forDashBoard: true
            }).createElement());
        } else if (block.editScreenActionsBlock) {
            let editActionBlock = new actionBlock.EditActionBlock(block, metaData, presenter);
            if (editActionBlock.hasActions) {
                let actionBlockElement = editActionBlock.render(presenter.entityType);
                groups.append(actionBlockElement);
                presenter.addActionBlockToSearchableWidgets(pageIndex, editActionBlock, actionBlockElement);
            }

        } else if (block.editScreenList) {
            groups.append(new EmbeddedListView({
                owner: presenter,
                block: block,
                editPresenter: presenter
            }).createElement());
        } else if (block.editScreenReport) {
            groups.append(new EmbeddedReportAndDashboardView({
                owner: presenter,
                block: block,
                editPresenter: presenter
            }).createElement());
        } else if (block.editScreenBlock) {
            groups.append(createBlockWidgetFor(presenter, block, groups));
        }
    }
    initGroupsPanel(groups, presenter);
    return groupsContainer;
}

function saveGroupStatToLocalStorage(item, presenter, collapse) {
    let itemId = item.attr("id");
    if (!itemId)
        return;
    let itemKey = presenter.panelBarItemKey(itemId);
    if (collapse)
        localStorage.setItem(itemKey, "true");
    else
        localStorage.removeItem(itemKey);
}

function initGroupsPanel(groups, presenter) {
    groups.kendoPanelBar({
        animation: false
    });
    $(groups).find("li > span.k-link.k-header").click(function (e) {
        let item = $(e.target).closest("li");
        if (item.hasClass("k-state-active")) {
            saveGroupStatToLocalStorage(item, presenter, true);
        } else {
            saveGroupStatToLocalStorage(item, presenter);
        }
    });

}

function createPageGroupsContainer() {
    return $(`
        <div class="pageTabDiv">
            <ul class="ra-well-overlay pagePanelsContainer"></ul>
        </div>
    `);
}

function registerResizeEventIfNeeded(root) {
    registerOnWindowResize(root.find("#tabstrip")[0], (e) => {
        setMaxHeightOfTabStrip(root);
    })
}

/**
 *
 * @param {NamaJquery} containerDiv
 */
export function setMaxHeightOfTabStrip(root) {

    let containerDiv = root.find("#tabstrip");
    let windowHeight = $(window).outerHeight(true);
    let navBarHeight = $("#nama-erp-header").outerHeight(true);
    let topPanelHeight = root.find(".page-top-header").outerHeight(true);
    let ulHeight = root.find("ul#pageTabs").outerHeight(true);

    let h = windowHeight - navBarHeight - topPanelHeight - ulHeight - 15;
    //TODO: handle in popups differently
    containerDiv.children(":not(.k-tabstrip-items)").css("max-height", h);
    containerDiv.children(".pageTabDiv").css("height", h);
    root.find("#splitter").css("height", h);
    let tabStrip = containerDiv.data("kendoTabStrip");
    if (tabStrip)
        tabStrip.resize();
    let toolbar = root.find("#toolbar").data("kendoToolBar");
    if (toolbar)
        toolbar.resize();
}